module.exports = __webpack_public_path__ + "static/media/_F13-three_js.d2ef5712.svg";